import React, { useEffect, useState } from "react";
import { Drawer, Button, Form, Select } from "antd";
import CapacityDatePicker from "../../components/CapacityDatePicker";

import { all as AllCareUnit } from "../../api/CareUnit.js";
import {
  create as CreateTransfer,
  update as UpdateTransfer,
  getOne as GetTransfer
} from "../../api/SurgicalInterventionTransfer.js";

import moment from "moment";
import { formatFirstname, formatLastname } from '../../utils';

const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3",
  },
};

const TransferInterventionForm = (props) => {
  const { surgicalIntervention, transferInterventionId } = props;
  const [form] = Form.useForm();
  const [careUnits, setCareUnits] = useState([]);
  const [selectedCareUnitId, setSelectedCareUnitId] = useState(null);

  const onClose = () => {
    props.onClose();
  };

  const onFinish = async () => {
    if (transferInterventionId) {
      UpdateTransfer(transferInterventionId, {
        start_at: form.getFieldValue("start_at").startOf("day"),
        end_at: form.getFieldValue("end_at").startOf("day"),
        surgical_intervention_id: surgicalIntervention.id,
        care_unit_id: form.getFieldValue("care_unit_id"),
      }).then(() => {
        props.onFinish();
      });
    } else {
      CreateTransfer({
        care_unit_id: form.getFieldValue("care_unit_id"),
        start_at: form.getFieldValue("start_at").startOf("day"),
        end_at: form.getFieldValue("end_at").startOf("day"),
        surgical_intervention_id: surgicalIntervention.id,
      }).then(() => {
        props.onFinish();
      });
    }
  };

  /**
   *
   * @param {*} search
   */
  const fetchCareUnits = async function () {
    AllCareUnit({
      current: 1,
      pageSize: 100,
      q: {},
    }).then((data) => {
      setCareUnits(data.results);
    });
  };

  /**
   *
   * @param {*} e
   */
  const onChangeCareUnit = (e) => {
    setSelectedCareUnitId(e);
  };

  useEffect(() => {
    if (props.visible && surgicalIntervention) {
      fetchCareUnits().then(() => {
        if (transferInterventionId) {
          GetTransfer(transferInterventionId).then((data) => {
            setSelectedCareUnitId(data.care_unit_id);
            form.setFieldsValue({
              care_unit_id: data.care_unit_id,
              start_at: moment(data.start_at),
              end_at: moment(data.end_at),
            });
          })
        } else {
          let intervention_start_at = moment(surgicalIntervention.start_at);
          setSelectedCareUnitId(surgicalIntervention.care_unit_id);
          form.setFieldsValue({
            care_unit_id: surgicalIntervention.care_unit_id,
            start_at: (moment() > intervention_start_at) ? moment() : intervention_start_at,
            end_at: moment(surgicalIntervention.expected_end_at),
          });
        }
      });
    }
  }, [surgicalIntervention, props.visible, transferInterventionId]);

  let careUnitOptions = careUnits.map((option, index) => (
    <Option key={index} value={option.id}>
      {option.name}
    </Option>
  ));

  let { patient=null } = surgicalIntervention || null;

  let title = ["Nouveau transfert"];
  if (transferInterventionId) {
    title = ["Modification de transfert"];
  }

  if (patient) {
    title.push(
      "de",
      formatFirstname(patient.firstname),
      formatLastname(patient.lastname),
      "-",
      moment(patient.birthdate).format("DD/MM/YYYY"),
    );
  }

  return (
    <Drawer
      width={800}
      title={title.join(' ')}
      placement="left"
      visible={props.visible}
      onClose={onClose}
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <div>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Annuler
            </Button>
            <Button onClick={onFinish} type="primary">
              Enregistrer
            </Button>
          </div>
        </div>
      }
    >
      <Form {...layout} form={form} name="care_unit">
        <Form.Item
          label="Nouvelle unité de soin"
          name="care_unit_id"
          rules={[
            {
              required: true,
              message: "La sélection d'une unité de soin est obligatoire",
            },
          ]}
        >
          <Select
            placeholder="Sélectionnez une unité"
            notFoundContent="Tapez pour rechercher une unité de soin"
            onChange={onChangeCareUnit}
          >
            {careUnitOptions}
          </Select>
        </Form.Item>
        <Form.Item
          label="Début du transfert"
          name="start_at"
          rules={[{ required: true }]}
        >
          <CapacityDatePicker
            format="DD/MM/YYYY"
            allowClear={false}
            careUnitId={selectedCareUnitId}
          />
        </Form.Item>
        <Form.Item
          label="Fin du transfert"
          name="end_at"
          rules={[{ required: true }]}
        >
          <CapacityDatePicker
            format="DD/MM/YYYY"
            allowClear={false}
            careUnitId={selectedCareUnitId}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default TransferInterventionForm;
